module.exports = __webpack_public_path__ + "img/mongo.2ce6f3c0.png";